export default __webpack_public_path__ + "static/media/Snd_LowerDHelicopter.538567d4.mp3";